<ng-container *transloco="let t">
  <mat-toolbar class="tool-bar">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center">
      <h1>{{ t("role.assignRole") }}</h1>
      <span class="example-spacer"></span>
      <mat-icon mat-dialog-close>close</mat-icon>
    </mat-toolbar-row>
  </mat-toolbar>
  <form [formGroup]="assignRoleForm" (ngSubmit)="submit()">
    <mat-dialog-content class="mat-typography">
      <div fxLayout="row wrap" class="padding-top-bottom-10">
        <div fxFlex="100">
          <mat-chip-set aria-label="Role selection">
            <mat-chip *ngFor="let role of data.selectedUserRoles" (removed)="removeRole(role)">{{ role }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-set>
        </div>
        <div fxFlex="100" class="padding-top-bottom-10">
          <mat-form-field class="example-full-width">
            <mat-error *ngIf="roleName?.errors?.['required']">{{
              t("role.selectRole")
              }}</mat-error>
            <mat-error *ngIf="roleName?.errors?.['forbiddenNames']">{{
              t("role.selectProperRole")
              }}</mat-error>
            <input type="text" matInput [matAutocomplete]="auto" formControlName="roleName" />
          </mat-form-field>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let role of userNotInRoles" [value]="role">
              {{ role }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
    </mat-dialog-content>
    <div fxLayout="row" class="dialog-actions">
      <button type="submit" mat-flat-button color="primary" [disabled]="assignRoleForm.invalid">
        ASSIGN
      </button>
      <button mat-stroked-button class="margin-left-right-10" (click)="onClose()">
        CANCEL
      </button>
    </div>
  </form>
</ng-container>